import axios from "axios";

import endPoints from "../../../../../config/endPoints";

export const getAllServices = async(reqBody) => {  
  return await axios.post(endPoints.services, reqBody);  
};
